import * as next from '../../../types/next'
import { CONTROL_NAME } from '../../../utils'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.AppBlock> = (uischema) => {
  if (uischema.type !== CONTROL_NAME.APP_CONTROL) {
    throw new Error('Expected a valid AppBlockControl control')
  }

  return {
    type: next.BLOCK_TYPE.APP,
    required: false, // can never be required
    settings: {
      ...upCommonSettings(uischema),
      // We define the type here because custom block is also being migrate to App
      type: next.AppType.INSTALLED_APP,
      appId: uischema.options?.appId,
      bundleURL: uischema.options?.bundleURL,
      componentId: uischema.options?.componentId,
      tag: uischema.options?.tagName,
      args: uischema.options?.args
    }
  }
}
